import API from 'src/api'
import { http } from '../boot/axios'

export default {
  URL: API.URL,
    GRAPHQL_URL: `${API.GRAPHQL_URL}`,
    createNotice (payload) {
      return http.post(`${this.GRAPHQL_URL}organization-notices/`, payload)
        .then(res => res.data)
        .catch(error => { throw error })
    },
    fetchNotices (is_admin = false, limit_by = null) {
      const params = { 'is_admin': is_admin }
      if (limit_by) {
        params.limit_by = limit_by
      }
      return new Promise((resolve, reject) => {
        http.get(`${this.GRAPHQL_URL}organization-notices`, { params })
          .then(res => {
            resolve(res.data)
          })
          .catch(error => { reject(error) })
      })
    },
    fetchNotice (id) {
      return http.get(`${this.GRAPHQL_URL}organization-notices/${id}`)
        .then(res => res.data)
        .catch(error => { throw error })
    },
    updateNotice (id, payload) {
      return http.put(`${this.GRAPHQL_URL}organization-notices/${id}`, payload)
        .then(res => res.data)
        .catch(error => { throw error })
    },
    fetchAudienceRoles () {
      return http.get(`${this.GRAPHQL_URL}organization-notices/audience/roles`)
        .then(res => res.data.data)
        .catch(error => { throw error })
    },
    // Paginado y con busqueda: una organizacion puede tener miles de ubicaciones.
    fetchAudienceLocations (params) {
      return http.get(`${this.GRAPHQL_URL}organization-notices/audience/locations`, { params })
        .then(res => res.data)
        .catch(error => { throw error })
    },
    uploadEditorImage (file) {
      const form = new FormData()
      form.append('image', file)
      return http.post(`${this.GRAPHQL_URL}organization-notices/editor-images`, form)
        .then(res => res.data.url)
        .catch(error => { throw error })
    },
    deleteNotice (id) {
      return new Promise((resolve, reject) => {
        http.delete(`${this.GRAPHQL_URL}organization-notices/${id}`)
          .then(response => { resolve(response.data) })
          .catch(error => { reject(error) })
      })
    },
    markAsRead (id) {
      return new Promise((resolve, reject) => {
        http.post(`${this.GRAPHQL_URL}organization-notices/${id}/mark-as-read`)
          .then(response => { resolve(response.data) })
          .catch(error => { reject(error) })
      })
    }
}
